import { z } from "zod/v4";

import { ExperienceDtoSchema } from "./experiences";

export const ExperienceWebhookActionTypeList = [
  "startExperience",
  "pauseExperience",
  "endExperience",
  "createExperience",
  "updateExperience",
  "deleteExperience",
] as const;
export type ExperienceWebhookActionType =
  (typeof ExperienceWebhookActionTypeList)[number];

export const ExperienceWebhookPayloadDtoSchema = ExperienceDtoSchema.pick({
  id: true,
  name: true,
  isPreview: true,
  description: true,
  organizationId: true,
  type: true,
  category: true,
  status: true,
  testTypes: true,
  experienceActions: true,
  currency: true,
  variations: true,
  createdAtTs: true,
  isDeleted: true,
  lastUpdateTs: true,
  productVariantCount: true,
  sourceExperienceId: true,
  sourceAction: true,
});

export type ExperienceWebhookPayloadDto = z.infer<
  typeof ExperienceWebhookPayloadDtoSchema
>;

export const WebhookDtoSchema = z.object({
  id: z.string().uuid(),
  actionTypes: z.enum(ExperienceWebhookActionTypeList).array(),
  url: z.url(),
  enabled: z.boolean(),
  secret: z.string(),
});

export type WebhookDto = z.infer<typeof WebhookDtoSchema>;
